const Vue = require('vue');
const { getObjectValue } = require('@root/helpers');

module.exports = {
	app_name: (state, getters) => getters.currentTeam.app_name,
	currentTeam: (state) => state.currentTeam,
	drawerSizes: (state) => state.drawerSizes,
	items: (state) => state.items,
	displaySetting: (state, getters) => (name, persistent = false) => {
		if (persistent && state[name] === null) {
			return getObjectValue(`user.user_settings.${name}`, getters);
		}

		return state[name];
	},
	fluid: (state, getters) => getters.displaySetting('fluid', true) == true,
	dark: (state, getters) => false,
	// dark: (state, getters) => getters.displaySetting('dark', true) == true,
	mini: (state, getters) => getters.displaySetting('mini', true) == true,
	notifications: (state) => state.notifications,
	privacy: (state, getters) => false, //Set false until we know what to do with it.
	// privacy: (state, getters) => getters.displaySetting('privacy', true),
	primaryDrawer: (state, getters) =>
		getters.displaySetting('primaryDrawer', true),
	profileDrawer: (state) => state.profileDrawer,
	searchQuery: (state) => state.searchQuery,
	theme: (state) => state.theme,
	statesList: () => (country = 'US') => {
		// if (key) {
		// 	return _.map(Spark.states, key);
		// }
		// if (Spark.states) {

		// }

		return getObjectValue(country, Spark.states, null);
	},
	// statesAbbv: (state, getters) => getters.statesList('abbreviation'),
	// statesNames: (state, getters) => getters.statesList('name'),
	user: (state) => state.user,
	users: (state) => state.users,
	getValue: (state, getters) => (path, state = false) => {
		let obj = getters;

		if (state) {
			obj = state;
		}

		return obj[path];
	},
};
